@if ($model() != null && $currentUser() != null && $isBootstrapFinished()) {
    <div class="wrapper px-1">
        <!-- Seletor de papel -->
        @if ($shouldLetPublicAgentInteract() && $hasPendingTask() && $papeisSelector().length > 0 && !$isReadOnly() && $canAddToProcess()) {
            <papel-selector [_signerId]="$inputData().eDocsData?.signerId"
                            [_isReadOnly]="$isReadOnly()"
                            [_papeis]="$papeisSelector()"
                            [_flowObjectType]="FlowObjectType.TaskAddToProcess"
                            (_signerIdChange)="signerIdChange($event)"
            ></papel-selector>
        }

        @if ($shouldLetPublicAgentInteract() && $previousDocuments().length > 0) {
            <!-- Task body: visão do executor -->
            <hr />
            <div class="message-container mt-2">
                <div>Conteúdo {{($hasPendingTask() ? 'para entranhamento' : 'entranhado')}}:</div>
                <div class="documents-container my-3">
                    @for (doc of $previousDocuments(); track doc) {
                        <div class="position-relative my-1">
                            <span class="document-highlight" (click)="openDocumentModal(doc.id)" (keydown.enter)="openDocumentModal(doc.id)">
                                <span class="e-docs info-font text-highlight" matTooltip="Protocolo E-Docs do documento">{{doc.registro}}</span>
                                <span class="info-font d-inline-block" matTooltip="Clique para visualizar o documento que foi capturado no E-Docs">
                                    <i class="fas fa-external-link-alt mr-1"></i><u class="summary">{{doc.filename}}</u>
                                </span>
                            </span>
                        </div>
                    }
                </div>
            </div>
        }

        <!-- Task info: Iniciada -->
        @if ($hasPendingTask() && $shouldLetPublicAgentInteract() && $summaryHasNoTagsLeft()) {
            <!-- Task body: visão do executor -->
            <hr />
            <div class="message-container">
                <div>Justificativa do Entranhamento:</div>
                <div class="my-3">
                    <span class="info-font text-highlight d-inline-block p-2"
                          [safeHtmlContent]="getAddToProcessSummary()"
                    >(Carregando...)</span>
                </div>
            </div>
        }

        <!-- Task info: Iniciada -->
        @if ($hasPendingTask() && $shouldLetPublicAgentInteract()) {
            <!-- Task body: visão do executor -->
            <hr />
            <div class="message-container">
                @if ($configSchema()?.taskAddToProcess?.processOrigin != Enums.ProcessOrigin.PublicAgentDeliberation) {
                    <div class="process-container mb-2">
                        @if ($canAddToProcess()) {
                            <div class="mb-3">Processo identificado:</div>
                            <span class="document-highlight" (click)="goToProcess()" (keydown.enter)="goToProcess()">
                                <span class="e-docs info-font text-highlight" matTooltip="Protocolo E-Docs do processo">{{$processProtocol()}}</span>
                                <span class="info-font d-inline-block" matTooltip="Resumo do Processo">
                                    <i class="fas fa-external-link-alt mr-1"></i><u class="summary">{{$process()?.resumo}}</u>
                                </span>
                            </span>
                        } @else {
                            @if ($isProcessInvalidStatus()) {
                                <div class="mt-2">
                                    <span class="not-found info-font text-highlight p-2">
                                        O processo <span class="e-docs info-font text-highlight" matTooltip="Protocolo E-Docs do processo">{{$processProtocol()}}</span>
                                        não se encontra em um estado <b>Ativo/Em Andamento</b>
                                    </span>
                                </div>
                            } @else {
                                @if (!PROCESS_MASK_REGEX.test($processProtocolFromForm())) {
                                    <div class="mt-2">
                                        <span class="not-found info-font text-highlight p-2">
                                            Protocolo inválido fornecido pelo usuário solicitante
                                        </span>
                                    </div>
                                } @else {
                                    <div class="mt-2">
                                        <span class="not-found info-font text-highlight p-2">
                                            Processo não encontrado a partir do protocolo fornecido pelo usuário solicitante
                                        </span>
                                    </div>
                                }

                                <div class="mt-4">
                                    <div class="mb-3">Campo do formulário:</div>
                                    <span class="info-font text-highlight p-2">{{$processProtocolFormFieldName()}}</span>
                                </div>

                                <div class="mt-3">
                                    <div class="mb-3">Valor fornecido:</div>
                                    <span class="info-font text-highlight p-2">{{$processProtocolFromForm()}}</span>
                                </div>
                            }

                            <div class="mt-5">
                                <span class="info-font document-highlight p-2">
                                    No contexto atual, a única ação possível para esta instância de Fluxo é o seu cancelamento
                                </span>
                            </div>
                        }
                    </div>
                } @else {
                    <div class="process-container process-protocol-container">
                        <label for="inputProcessProtocol" class="form-label">Entre com o protocolo do processo:</label>
                        <input type="text" class="process-protocol form-control" id="inputProcessProtocol" placeholder="XXXX-XXXXX" maxlength="10"
                                [class.is-invalid]="!$isProcessProtocolValid()"
                                [(ngModel)]="$inputProcessProtocol"
                        />

                        @if (!$isProcessProtocolValid()) {
                            <div class="invalid-feedback d-block mt-1">
                                Formato inválido.
                            </div>
                        }

                        <button type="button" class="btn btn-outline-success mt-4 mb-1" [disabled]="!$isProcessProtocolValid()" (click)="checkProcess($inputProcessProtocol())">
                            Buscar Processo
                        </button>

                        @if ($hasFoundProcess() == false) {
                            <div class="mt-4 mb-1">
                                <span class="not-found info-font text-highlight p-2">Processo não encontrado</span>
                            </div>
                        } @else if ($canAddToProcess()) {
                            <div class="my-3">Processo identificado:</div>
                            <span class="document-highlight" (click)="goToProcess()" (keydown.enter)="goToProcess()">
                                <span class="e-docs info-font text-highlight" matTooltip="Protocolo E-Docs do processo">{{$processProtocol()}}</span>
                                <span class="info-font d-inline-block" matTooltip="Resumo do Processo">
                                    <i class="fas fa-external-link-alt mr-1"></i><u class="summary">{{$process()?.resumo}}</u>
                                </span>
                            </span>
                        }
                    </div>
                }
            </div>

            @if ($canAddToProcess()) {
                <hr />
                <div class="message-container">
                    <div>Processo sob custódia de:</div>
                    <div class="my-3">
                        <span class="uppercase info-font text-highlight d-inline-block">{{$custodyHolder()}}</span>
                    </div>
                </div>
            }
        }

        @if (!$hasPendingTask()) {
            <!-- Task info: Realizada -->
            <hr />
            <div class="process-container my-2">
                <div class="mb-3">Processo identificado:</div>
                <span class="document-highlight" (click)="goToProcess()" (keydown.enter)="goToProcess()">
                    <span class="e-docs info-font text-highlight" matTooltip="Protocolo E-Docs do Processo">{{$processProtocol()}}</span>
                    <span class="info-font d-inline-block" matTooltip="Resumo do Processo">
                        <i class="fas fa-external-link-alt mr-1"></i><u class="summary">{{$process()?.resumo}}</u>
                    </span>
                </span>
            </div>

            <hr />
            <div class="message-container">
                <div class="mb-3">
                    Processo sob custódia de:
                </div>
                <div class="mb-3">
                    <span class="uppercase info-font text-highlight d-inline-block">{{$custodyHolder()}}</span>
                </div>
            </div>
        } @else {
            <!-- Task info: Iniciada -->
            @if (!$shouldLetPublicAgentInteract()) {
                <!-- Task body: visão do requerente -->
                <hr />
                <div class="message-container">
                    <div class="mb-3">
                        Aguardando entranhamento em Processo por:
                    </div>
                    <div>
                        <span class="uppercase info-font text-highlight d-inline-block">{{$currentLocation()}}</span>
                    </div>

                    @if (Utils.isNotNullOrEmpty($publicMessageHtml())) {
                        <hr />
                        <div class="public-message py-1"
                             [class.loading]="$isPublicMessageHtmlLoading()"
                             [safeHtmlContent]="$publicMessageHtml()"
                        >{{Enums.Messages.DefaultLoadingText}}</div>
                    }
                </div>
            } @else {
                <!-- Task footer: visão do executor -->
                @if (!$isReadOnly() && $canAddToProcess()) {
                    <hr />
                    <div class="form-container">
                        <div class="footer">
                            <button type="button" class="btn btn-outline-primary" (click)="submit()">
                                Entranhar em Processo
                            </button>
                        </div>
                    </div>
                }
            }
        }
    </div>
} @else {
    <div class="wrapper loading">
        <span class="info-font text-highlight p-2">(Carregando...)</span>
    </div>
}
